import { render } from "./personalPage.vue?vue&type=template&id=bf4b7e70"
import script from "./personalPage.vue?vue&type=script&lang=js"
export * from "./personalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__